import { Theme, alpha } from '@mui/material/styles';

export type StatCardColor =
  | 'violet'
  | 'slateBlue'
  | 'cyan'
  | 'teal'
  | 'orange'
  | 'rose';

export type StatCardTokens = {
  background: string;
  border: string;
  iconBackground: string;
  iconColor: string;
  textColor: string;
  hoverBackground: string;
  hoverShadow: string;
};

type StatCardColorConfig = {
  surface: string;
  textColor: string;
  iconColor: string;
  hoverBackground: string;
};

export const getStatCardTokens = (
  theme: Theme,
  color: StatCardColor
): StatCardTokens => {
  const isDarkMode = theme.palette.mode === 'dark';
  const hoverBgColor = isDarkMode ? 300 : 200;

  const colorConfig: Record<StatCardColor, StatCardColorConfig> = {
    violet: {
      surface: theme.palette.semantic.surface.violet,
      textColor: theme.palette.semantic.text.violet,
      iconColor: theme.palette.semantic.icon.violet,
      hoverBackground: theme.palette.colors.violet[hoverBgColor],
    },
    slateBlue: {
      surface: theme.palette.semantic.surface.primary2,
      textColor: theme.palette.semantic.text.darkBlue,
      iconColor: theme.palette.semantic.icon.darkBlue,
      hoverBackground: theme.palette.colors.info[hoverBgColor],
    },
    cyan: {
      surface: theme.palette.semantic.surface.blue,
      textColor: theme.palette.semantic.text.darkBlue,
      iconColor: theme.palette.semantic.text.darkBlue,
      hoverBackground: theme.palette.colors.info[hoverBgColor],
    },
    teal: {
      surface: theme.palette.semantic.surface.success,
      textColor: theme.palette.semantic.text.success,
      iconColor: theme.palette.semantic.icon.success,
      hoverBackground: theme.palette.colors.success[hoverBgColor],
    },
    orange: {
      surface: theme.palette.semantic.surface.warning,
      textColor: theme.palette.semantic.text.warning,
      iconColor: theme.palette.semantic.icon.warning,
      hoverBackground: theme.palette.colors.amber[hoverBgColor],
    },
    rose: {
      surface: theme.palette.semantic.surface.error,
      textColor: theme.palette.semantic.text.error,
      iconColor: theme.palette.semantic.icon.error,
      hoverBackground: theme.palette.colors.error[hoverBgColor],
    },
  };

  const config = colorConfig[color];

  return {
    background: config.surface,
    border: config.surface,
    iconBackground: alpha(theme.palette.common.black, 0.2),
    iconColor: config.iconColor,
    textColor: config.textColor,
    hoverBackground: config.hoverBackground,
    hoverShadow: 'none',
  };
};
